module.exports = __webpack_public_path__ + "static/img/view10-7.e3e267f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view10-7.png
// module id = ctxQ
// module chunks = 1